import { Component, Input, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from '@angular/material/table';
import { ViewChild } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";

import { VersionListModel } from "./../../../models/versionModel/version-list-model";
import { VersionService } from "./../../../core/services/version.service";
import { ModalNotificationComponent } from "../modal-notification/modal-notification.component";
import { GlobalComponents } from "../global-constants";

@Component({
  selector: "app-modal-editions-meeting",
  templateUrl: "./modal-editions-meeting.component.html",
  styleUrls: ["./modal-editions-meeting.component.scss"],
})

export class ModalEditionsMeetingComponent implements OnInit {
  @Input() meetingId: number;
  public versionList: Array<VersionListModel>;
  public searching: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public obs: Observable<any>;
  public dataSource: MatTableDataSource<any>;

  constructor(private dialog: MatDialog,
              private changeDetectorRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<ModalEditionsMeetingComponent>,
              public versionService: VersionService) {}

  ngOnInit(): void {
    this.searching = true;
    this.getDataMeeting(this.meetingId);
  }

  closeModal() {
    this.dialogRef.close();
  }

  getDataMeeting(meetingId: number) {
    this.versionService.getVersionsMeeting(meetingId).subscribe((resp) => {
      this.searching = false;
      this.versionList = resp.data;

      this.dataSource = new MatTableDataSource<any>(this.versionList);
      this.changeDetectorRef.detectChanges();
      this.dataSource.paginator = this.paginator;
      this.obs = this.dataSource.connect();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string){
    const dialogConfig = new MatDialogConfig();    
    dialogConfig.data = {
      message: message,
      valor:10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }
}
